export interface MarkOutsideProcessContractMovementAsReceivedDto {
	dateReceived: Date;
	outsideProcessContractMovementId: number;
	quantityReceived: number;
}

export class MarkOutsideProcessContractMovementAsReceivedDto implements MarkOutsideProcessContractMovementAsReceivedDto {
	constructor(data?: Partial<MarkOutsideProcessContractMovementAsReceivedDto>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}